"use client";
import Link from "next/link";
import { useFormik } from "formik";
import * as formValidation from "@/utils/validations";
import { handleForgetPassword } from "@/components/features/auth/authSlice";
import { notify, warn } from "@/utils/notification";
import { useState } from "react";

const ForgotAccount: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const forgot = async () => {
    try {
      setLoading(true);
      if (formik.isValid) {
        const formData = {
          email: formik.values.email,
        };
        const response = await handleForgetPassword(formData);
        if (response) {
          notify(response);
        } else {
          warn("Unable to send password link.");
        }
      }
      setLoading(false);
    } catch (error) {
      console.error("Fail to Validate Forgot", error);
    }
  };

  const formik = useFormik({
    validate: formValidation.validateForgotPassword,
    initialValues: {
      email: "",
    },
    onSubmit: forgot,
  });
  return (
    <div className="flex bg-slate-300/90 backdrop-blur-none flex-col justify-center px-6 py-4 lg:px-20 rounded-2xl border-b-2 border-slate-400">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
          Forgot your account
        </h2>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form className="space-y-6" onSubmit={formik.handleSubmit}>
          <div className="mt-2">
            <input
              id="email"
              type="email"
              autoComplete="email"
              className="block w-full rounded-md border-0 py-3 px-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-orange-600 sm:text-sm sm:leading-6"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />
            {formik.touched.email && formik.errors.email ? (
              <p className="text-sm text-red-800 font-normal">
                {formik.errors.email}
              </p>
            ) : null}
          </div>

          <div>
            <button
              type="submit"
              className="flex w-full justify-center rounded-md bg-orange-600 px-3 py-3 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600"
            >
              {!loading ? "Forgot Password" : "Loading.."}
            </button>
          </div>
        </form>

        <p className="mt-10 text-center text-sm text-gray-500">
          Are you member?{" "}
          <Link
            href="/auth"
            className="font-semibold leading-6 text-orange-600 hover:text-orange-500"
          >
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotAccount;
